"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const GridComponent_scss_1 = __importDefault(require("./GridComponent.scss"));
function GridComponent({ rows, cols, children, colFractions, rowFractions }) {
    const gridStyle = (0, react_1.useMemo)(() => {
        const rowsTemplate = rowFractions ? rowFractions.map((fr) => `${fr}fr`).join(' ') : `repeat(${rows}, 1fr)`;
        const colsTemplate = colFractions ? colFractions.map((fr) => `${fr}fr`).join(' ') : `repeat(${cols}, 1fr)`;
        return {
            gridTemplateRows: rowsTemplate,
            gridTemplateColumns: colsTemplate,
        };
    }, [rows, cols, colFractions, rowFractions]);
    return (react_1.default.createElement("div", { className: GridComponent_scss_1.default.gridContainer, style: gridStyle }, children));
}
exports.default = GridComponent;
